
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/android/nodevice-setup",
      function () {
        return require("private-next-pages/android/nodevice-setup/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/android/nodevice-setup"])
      });
    }
  